// Translation: Account > Billing > Recurring transactions > Model transaction (German)
export default Object.freeze({
	label: {
		fallback: ''
	}
})
